import { Iso900114001ConfirmDialog } from "../../../components/shared/Iso900114001ConfirmDialog";

type Props = {
  open: boolean;
  title: string;
  description: string;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function RequisitoLegalDeleteModal({
  open,
  title,
  description,
  deleting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Iso900114001ConfirmDialog
      open={open}
      title={title}
      description={description}
      confirming={deleting}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
